import { globalLogger } from '../../qaamgo/helper/global-logger';
import { AuthFormValidatorHelper } from './auth-form-validator-helper';
import { testIsEmailValid } from './test';

class AuthFormValidator {
    constructor() {
        this._config = {};
        this._errorMessages = {};

        this.helper = new AuthFormValidatorHelper();
    }

    init(config) {
        this._config = config;
        this._errorMessages = config.errorMessages;

        var formValidationHelperConfig = {
            minPasswordLength: 8,
            maxPasswordLength: 256,
        };

        this.helper = new AuthFormValidatorHelper(formValidationHelperConfig);
    }

    scrollToError() {
        $.each($('.authAlert'), function (key, value) {
            if ($(value).is(':visible')) {
                var elem_position = $(value).offset().top;
                var window_height = $(window).height();
                var y = elem_position - window_height / 2;

                window.scrollTo(0, y);

                return false;
            }
        });
    }

    processGenericField($field, $fieldContainer, $errorContainer, errorMessage) {
        var results = {};

        results.fieldSet = this.helper.processFieldEmpty($field, $fieldContainer, $errorContainer, errorMessage);

        var foundError = false;
        $.each(results, function (key, value) {
            if (value !== true) {
                foundError = true;
                return false;
            }
        });

        if (foundError) {
            globalLogger.log('auth validator - generic field - fail', JSON.stringify(results));

            return results;
        }

        this.helper.resetFieldError($fieldContainer, $errorContainer);

        return true;
    }

    processEmail(checkEmailMismatch) {
        var $emailField = $('#email');
        var $emailFieldContainer = $('#formGroupEmail');
        var $errorContainer = $('#emailError');

        var results = {};

        results.emailSet = this.helper.processFieldEmpty(
            $emailField,
            $emailFieldContainer,
            $errorContainer,
            this._errorMessages.emailEmpty
        );

        results.emailValid = this.helper.processEmailInvalid(
            $emailField,
            $emailFieldContainer,
            $errorContainer,
            this._errorMessages.emailInvalid
        );

        var foundError = false;
        $.each(results, function (key, value) {
            if (value !== true) {
                foundError = true;
                return false;
            }
        });

        if (foundError) {
            globalLogger.log('auth validator - email field - fail', JSON.stringify(results));

            return results;
        }

        this.helper.resetFieldError($emailFieldContainer, $errorContainer);

        return true;
    }

    processEmailRetype() {
        var $emailField = $('#email_retype');
        var $emailFieldContainer = $('#formGroupEmailRetype');
        var $errorContainer = $('#emailRetypeError');

        var results = {};

        results.emailSet = this.helper.processFieldEmpty(
            $emailField,
            $emailFieldContainer,
            $errorContainer,
            this._errorMessages.emailEmpty
        );

        results.emailValid = this.helper.processEmailInvalid(
            $emailField,
            $emailFieldContainer,
            $errorContainer,
            this._errorMessages.emailInvalid
        );

        var foundError = false;
        $.each(results, function (key, value) {
            if (value !== true) {
                foundError = true;
                return false;
            }
        });

        if (foundError) {
            globalLogger.log('auth validator - email retype field - fail', JSON.stringify(results));

            return results;
        }

        this.helper.resetFieldError($emailFieldContainer, $errorContainer);

        return true;
    }

    processUsername() {
        var $usernameField = $('#username');
        var $usernameFieldContainer = $('#formGroupUsername');
        var $errorContainer = $('#usernameError');

        var results = {};

        results.usernameSet = this.helper.processFieldEmpty(
            $usernameField,
            $usernameFieldContainer,
            $errorContainer,
            this._errorMessages.usernameEmpty
        );

        if (testIsEmailValid($usernameField.val())) {
            return false;
        }

        var foundError = false;
        $.each(results, function (key, value) {
            if (value !== true) {
                foundError = true;
                return false;
            }
        });

        if (foundError) {
            globalLogger.log('auth validator - username field - fail', JSON.stringify(results));

            return results;
        }

        this.helper.resetFieldError($usernameFieldContainer, $errorContainer);

        return true;
    }

    processPassword(checkPasswordFullValidity) {
        var $passwordField = $('#password');
        var $passwordFieldContainer = $('#formGroupPassword');
        var $errorContainer = $('#passwordError');

        var results = {};

        if (checkPasswordFullValidity === true) {
            results.passwordValid = this.helper.processPasswordInvalid(
                $passwordField,
                $passwordFieldContainer,
                $errorContainer,
                this._errorMessages.passwordInvalid
            );

            results.passwordLongEnough = this.helper.processPasswordTooShort(
                $passwordField,
                $passwordFieldContainer,
                $errorContainer,
                this._errorMessages.passwordTooShort
            );
            results.passwordTooLong = this.helper.processPasswordTooLong(
                $passwordField,
                $passwordFieldContainer,
                $errorContainer,
                this._errorMessages.passwordTooLong
            );
        }

        results.passwordSet = this.helper.processFieldEmpty(
            $passwordField,
            $passwordFieldContainer,
            $errorContainer,
            this._errorMessages.passwordEmpty
        );

        var foundError = false;
        $.each(results, function (key, value) {
            if (value !== true) {
                foundError = true;
                return false;
            }
        });

        if (foundError) {
            globalLogger.log('auth validator - password field - fail', JSON.stringify(results));

            return results;
        }

        this.helper.resetFieldError($passwordFieldContainer, $errorContainer);

        return true;
    }

    processPasswordRetype() {
        var $passwordFieldRetype = $('#password_retype');
        var $passwordField = $('#password');
        var $passwordFieldContainer = $('#formGroupPasswordRetype');
        var $errorContainer = $('#passwordRetypeError');

        var results = {};
        var fields = {
            $fieldOne: $passwordField,
            $fieldTwo: $passwordFieldRetype,
        };

        results.passwordValid = this.helper.processPasswordInvalid(
            $passwordFieldRetype,
            $passwordFieldContainer,
            $errorContainer,
            this._errorMessages.passwordInvalid
        );

        results.passwordLongEnough = this.helper.processPasswordTooShort(
            $passwordFieldRetype,
            $passwordFieldContainer,
            $errorContainer,
            this._errorMessages.passwordTooShort
        );

        results.passwordTooLong = this.helper.processPasswordTooLong(
            $passwordField,
            $passwordFieldContainer,
            $errorContainer,
            this._errorMessages.passwordTooLong
        );

        results.passwordRetypeSet = this.helper.processFieldEmpty(
            $passwordFieldRetype,
            $passwordFieldContainer,
            $errorContainer,
            this._errorMessages.passwordEmpty
        );

        results.passwordRetypeSet = this.helper.processFieldsMismatch(
            fields,
            $passwordFieldContainer,
            $errorContainer,
            this._errorMessages.passwordMismatch
        );

        var foundError = false;
        $.each(results, function (key, value) {
            if (value !== true) {
                foundError = true;
                return false;
            }
        });
        if (foundError) {
            globalLogger.log('auth validator - password retype field - fail', JSON.stringify(results));
            return results;
        }

        this.helper.resetFieldError($passwordFieldContainer, $errorContainer);

        return true;
    }

    processTos() {
        var $tosCheckbox = $('#acceptTos');
        var $tosCheckboxContainer = $('#formGroupTos');
        var $errorContainer = $('#acceptTosError');

        var results = {};

        results.tosAccepted = this.helper.processCheckboxChecked(
            $tosCheckbox,
            $tosCheckboxContainer,
            $errorContainer,
            this._errorMessages.acceptTos
        );

        var foundError = false;
        $.each(results, function (key, value) {
            if (value !== true) {
                foundError = true;
                return false;
            }
        });

        if (foundError) {
            globalLogger.log('auth validator - tos field - fail', JSON.stringify(results));

            return results;
        }

        this.helper.resetFieldError($tosCheckboxContainer, $errorContainer);

        return true;
    }
}

export { AuthFormValidator };
